import { useEffect } from 'react';

import { toast } from 'sonner';

import useNotification from '@/notifications/useNotification';

export default function DesignSubmittedNotification(): null {
  const { registerFlashHandler, unregisterFlashHandler } = useNotification();

  useEffect(() => {
    registerFlashHandler('designSubmitted', () =>
      toast.success(
        <span>
          Your design has been submitted to print. You can see updates here or
          in the Orders tab by{' '}
          <a
            className="text-[13px] font-medium underline hover:text-emerald-600"
            href="/shop"
          >
            clicking here
          </a>
          .
        </span>,
        { duration: 10000 },
      ),
    );
    return () => unregisterFlashHandler('designSubmitted');
  }, [registerFlashHandler, unregisterFlashHandler]);

  return null;
}
